/**
 * Created by OBL on 14/01/2016.
 */
define('adminKitlController',[
    'module',
    'underscore',
    'app',
    'adminKitlView',
    'bootbox',
    'kitlCreateEditLayoutView',
    'settings',
    'entities/kitl'
], function(
    module,
    _,
    App,
    View,
    bootbox,
    CreateEditLayoutView
    ) {
    'use strict';

    var SuperAdminKitlListController = {
        showKitlList: function(data) {
            this.data = data;
            var view = new View({data: data});
            this.view = view;
            view.listenTo(view, 'onGridLoaded', _.bind(this.onGridLoaded, this));
            view.listenTo(view, 'kitl:delete', _.bind(this.onDelete, this));
            App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion('kitlListTab').show(view);
        },

        showKitlAdd: function(mbKitSecId) {
            this.showKitlAddEdit(App.request('kitl:model', {
                refKit: {
                    secId: mbKitSecId
                }
            }), true);
        },

        showKitlAddEdit: function(model, newItem) {
            this.createEditView = new CreateEditLayoutView({
                kitlModel: model,
                newItem: newItem
            });
            this.createEditView.show({
                title: _.i18n('kitl.new')
            });
        },

        showKitlEdit: function(mbKitSecId, kitlSecId) {
            var that = this;
            var model = App.request('kitl:model', {
                refKit: {
                    secId: mbKitSecId
                },
                secId: kitlSecId
            });
            model.fetch().done(function() {
                that.showKitlAddEdit(model, false);
            });
        },

        onGridLoaded: function() {
            var kitSecId = this.data.model.get('refKitSecId')?
                this.data.model.get('refKitSecId'):this.data.model.get('secId');
            var data = {
                url: App.request('kitl:get-collection-url', kitSecId),
                rowCountUrl: App.request('kitl:get-count-url', kitSecId)
            };

            this.view.displayGrid(data);
        },

        onDelete: function(kitSecId, secId){
            bootbox.confirm(_.i18n('kitl.confirmDelete'), _.bind(function(result) {
                if(result){
                    App.request('kitl:delete', kitSecId, secId)
                        .done(_.bind(function(){
                            this.view.updatePagination('reloadGrid');
                        }, this));
                }
            }, this));
        }
    };

    module.exports = SuperAdminKitlListController;
});
